import { useInfiniteQuery, useMutation } from "react-query";
import useApi from "./useApiRequest";

const LIMIT = 20;

const fetchPage = (api, ajusteId, empresa, filtros, isClose, tagExc) => async ({ pageParam }) => {
  // pageParam trae { page, searchOnDoc }; define default
  const { page = 1, pageTag = 1, searchOnDoc = true } = pageParam || { page: 1, pageTag: 1, searchOnDoc: true };
  const res = await api.get(`/ajustes-inventario/movimientos-nuevo-ajuste/cliente/${ajusteId}`, {
    params: { page, pageTag, limit: LIMIT, searchOnDoc, empresa, filtros, isClose, tagExc },
  });

  const data = res.data; // adapta si tu backend envía otra estructura

  // deducir si se llegó al fin del “modo” actual:
  const items = data?.movs_inv || data?.items || data?.results || data?.rows || data?.data || [];
  const hasNextPageMovs = data?.hasNextPageMovs; // si no existe, usa: items.length === LIMIT
  // Calcula el PRÓXIMO pageParam:
  let nextPageParam = undefined;

  if (!hasNextPageMovs && items.length > 0) {
    let incMovs = items.some(i => i.fromDocMov === true);
    if (incMovs) {
      nextPageParam = { page: page + 1, pageTag: pageTag + 1, searchOnDoc: false }
    } else {
      nextPageParam = { pageTag: pageTag + 1, searchOnDoc: false }
    }
  } else if (items.length > 0) {
    nextPageParam = { page: page + 1, searchOnDoc: true }
  }

  // Devuelve datos + metadata para getNextPageParam
  return {
    items,
    hasNextPageMovs,
    used: { page, pageTag, searchOnDoc },             // por si lo quieres mostrar en UI
    nextPageParam,
  };
};

export const useInfiniteItemsAjusteCliente = (ajusteId, empresa, options = {}, filtros, isClose, tagExc) => {
  const api = useApi();
  return useInfiniteQuery(
    ["infiniteItemsAjusteCliente", { ajusteId, empresa, filtros: JSON.stringify(filtros), isClose: JSON.stringify(isClose) }],
    fetchPage(api, ajusteId, empresa, JSON.stringify(filtros), JSON.stringify(isClose), JSON.stringify(tagExc)),
    {
      // Empezamos en page=1, modo documentos (true)
      initialPageParam: { page: 1, pageTag: 1, searchOnDoc: true },

      // v3/v4: solo (lastPage, allPages)
      getNextPageParam: (lastPage /*, allPages */) => {
        return lastPage?.nextPageParam ?? undefined;
      },

      keepPreviousData: true,
      staleTime: 600,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: false,
      cacheTime: 30,
      ...options
    }
  );
};

export const ProcessAllCliente = () => {
  const api = useApi();

  const mutate = async (params) => {
    const data = await api.post(`/ajustes-inventario/process-all/cliente`, params, {
      dataType: "json",
      hasFormData: false,
      hasCustomUrl: false,
    });
    return data.data;
  };

  const mutation = useMutation(mutate);

  return {
    processAllClienteMutation: mutation.mutate,
  };
}
export const ProcessPartialCliente = () => {
  const api = useApi();

  const mutate = async (params) => {
    const data = await api.post(`/ajustes-inventario/process-all/partial/cliente`, params, {
      dataType: "json",
      hasFormData: false,
      hasCustomUrl: false,
    });
    return data.data;
  };

  const mutation = useMutation(mutate);

  return {
    processPartialClienteMutation: mutation.mutate,
  };
}